const country = {
  Uruguay: 1,
  Chile: 2,
  Argentina: 3,
  Peru: 7,
  Venezuela: 8,
  Panama: 11,
  Ecuador: 13,
  Paraguay: 15,
  CostaRica: 16,
  Bolivia: 17,
  RepDominicana: 18,
  ElSalvador: 19,
  Nicaragua: 20,
  Guatemala: 21,
  Honduras: 22,
};

export default country;
